import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  MissingUserInfoModalComponent, type MissingUserInfoModalProps,
} from './missingUserInfoModal.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    MissingUserInfo: MissingUserInfoModalProps;
  }
}

modalRenderer.register('MissingUserInfo', MissingUserInfoModalComponent);
